import { months } from '@/app/utils/numberToMonth'
import { useTranslation } from '@/app/i18n/client'
import React from 'react'

export const AvailableMonthList = (availableMonths: any | string[]) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row my-2 text-primary-foreground w-full gap-1.5 mobile:flex-wrap mobile:gap-[20px]">
      {months.map((month, index) => (
        <p
          key={index}
          className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-pn_regular not-italic leading-normal tracking-normal text-left ${
            availableMonths?.availableMonths?.includes(month)
              ? 'bg-secondary text-white'
              : 'bg-gray_btn text-primary-foreground'
          }`}
        >
          {t(month.substring(0, 3))}
        </p>
      ))}
    </div>
  )
}
